import useFactoringTutorial from '../hooks/useAvailableFactoringTutorial';
import useAvailableOffersTutorial from '../hooks/useAvailableOffersTutorial';

const HEADER_TUTORIALS = {
  available_factoring: {
    code: 'AVAILABLE_FACTORING',
    hook: useFactoringTutorial,
  },
  available_offers: {
    code: 'AVAILABLE_OFFERS',
    hook: useAvailableOffersTutorial,
  },
};

export default HEADER_TUTORIALS;
